import styled from 'styled-components';

export const WrapperHeader = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

export const StatusBarStyle = styled.div`
  display: flex;
  background-color: ${(props) => props.color};
  padding: 5px;
  margin: 0 5px 5px 0;
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  font-size: ${({ theme }) => {
    return theme.fonts.size.normal;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};
  p {
    margin: 0;
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
  }
  strong {
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.normal;
    }};
    color: ${({ theme }) => {
      return theme.colors.darkPrimary;
    }};
  }
`;
